module.exports = __webpack_public_path__ + "img/official.3ff3794c.jpg";